import React from 'react';
import type { Hero } from 'types/hero';

import { Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import Figure from './figure';

const HeroHighlight: React.FC<{ hero: Hero }> = ({
  hero: { subTitle, title, image },
}) => (
  <Wrap
    {...{
      className:
        'relative lg:grid-cols-2 lg:gap-x-12 items-center before:-z-1 before:pointer-events-none before:bg-gray-100 before:absolute before:bottom-0 before:left-1/2 before:-translate-x-1/2 before:w-screen before:h-screen',
      size: 'large',
      tagName: 'header',
    }}
  >
    <div className="grid gap-y-3">
      <HeadingBody
        {...{
          level: '2',
          tagName: 'h1',
          title,
        }}
      />
      <HeadingBody
        {...{
          level: '4',
          tagName: 'h2',
          title: subTitle,
        }}
      />
    </div>
    <Figure
      {...{
        ...image,
        className: 'hidden lg:block justify-self-end',
        objectFit: 'contain',
      }}
    />
  </Wrap>
);

export default HeroHighlight;
